import React, { useRef, useState } from 'react';
import * as R from 'ramda';

import { arrayOf, func, number, shape, string } from 'prop-types';

// Components
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { Button, IconButton, Menu, MenuItem } from '@mui/material';

// Styles
import { tabTitleStyles } from '../CardsPanel.styles';

// Utils
import { handleMenuButtonClick } from './HeaderButtons';

const MobileMenu = ({
  activeSupplierAuthTab,
  filterIdentifierCount,
  nameShort,
  setDialogDetails,
  toggleBatchActivation,
  supplierAuthorizationsCards,
  viewBy,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = R.compose(setMenuOpen, R.F);
  const handleMenuOpen = R.compose(setMenuOpen, R.T);

  const handleClick = type => {
    const supplierAuthorizationsCardsLength = supplierAuthorizationsCards?.length;
    handleMenuButtonClick(
      activeSupplierAuthTab,
      supplierAuthorizationsCardsLength,
      filterIdentifierCount,
      type,
      nameShort,
      setDialogDetails,
      supplierAuthorizationsCards,
      toggleBatchActivation,
      viewBy
    );
  };

  const menuAnchorRef = useRef(null);

  const handleOnButtonOnClick = () => {
    handleClick('activate');
    handleMenuClose();
  };
  const handleOffButtonOnClick = () => {
    handleClick('deactivate');
    handleMenuClose();
  };

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        ref={menuAnchorRef}
        size="large"
        sx={tabTitleStyles}
        type="button"
      >
        More
        <ArrowDropDownRoundedIcon />
      </IconButton>
      <Menu anchorEl={menuAnchorRef?.current} onClose={handleMenuClose} open={menuOpen}>
        <MenuItem>
          <Button
            disabled={R.all(R.propEq('active', true), supplierAuthorizationsCards)}
            disableRipple
            onClick={handleOnButtonOnClick}
            variant="text"
          >
            {`Turn ${
              supplierAuthorizationsCards && filterIdentifierCount
                ? `${supplierAuthorizationsCards.length} On`
                : 'On All'
            }`}
          </Button>
        </MenuItem>
        <MenuItem>
          <Button
            disabled={R.all(R.propEq('active', false), supplierAuthorizationsCards)}
            disableRipple
            onClick={handleOffButtonOnClick}
            variant="text"
          >
            {`Turn ${
              supplierAuthorizationsCards && filterIdentifierCount
                ? `${supplierAuthorizationsCards.length} Off`
                : 'Off All'
            }`}
          </Button>
        </MenuItem>
      </Menu>
    </>
  );
};

export default MobileMenu;

MobileMenu.propTypes = {
  activeSupplierAuthTab: string.isRequired,
  filterIdentifierCount: number.isRequired,
  nameShort: string,
  setDialogDetails: func.isRequired,
  supplierAuthorizationsCards: arrayOf(shape({})).isRequired,
  toggleBatchActivation: func.isRequired,
  viewBy: string,
};

MobileMenu.defaultProps = {
  nameShort: '',
  viewBy: '',
};
